<template>
  <article class="trainers">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Nuevo entrenador</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'classes_trainers'})"
                  class="breadcums__option"
                >
                  Entrenadores
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Nuevo entrenador
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-0">
              <button
                class="faccess_button px-5"
                @click="createLocation()"
              >
                Crear
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <v-layout row wrap>
          <v-flex xs6>
            <!-- Fotos de la oferta -->
            <span class="table_card__info--label">Foto</span>
            <div class="trainers__form--photo_container">
              <label
                for="trainerPhoto"
                class="faccess_button buttom_shadow px-5">Examinar</label>
              <input
                id="trainerPhoto"
                type="file"
                @change="onFileChange"
                name="logo">
              <p>{{ photo_name }}</p>
            </div>
            <v-flex xs12>
              <span class="table_card__info--label">Nombre</span>
              <input
                class="faccess_input"
                type="text"
                name="Name"
                placeholder="Nombre del entrenador"
                v-model="location.attributes.name">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Descripción</span>
              <input
                class="faccess_input"
                type="text"
                name="Name"
                placeholder="Descripción"
                v-model="location.attributes.description">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Dirección</span>
              <input
                class="faccess_input"
                type="text"
                name="Address"
                placeholder="Dirección"
                v-model="location.attributes.address">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Correo electrónico</span>
              <input
                class="faccess_input"
                type="email"
                name="Email"
                placeholder="Correo electrónico"
                v-model="location.attributes.email">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Teléfono</span>
              <input
                class="faccess_input"
                type="tel"
                name="Phone"
                placeholder="Numero de teléfono"
                v-model="location.attributes.telephone">
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Ciudad</span>
              <input
                class="faccess_input"
                type="text"
                name="City"
                placeholder="Ciudad"
                v-model="location.attributes.city">
            </v-flex>
          </v-flex>
          <v-flex xs6 class="preview_item">
            <v-flex xs12>
              <section class="data_card data_card__instance">
                <div
                  class="data_card__image"
                  :class = "{'without_url' : !url_change}"
                  :style="{backgroundImage: 'url('+ url +')'}"></div>
                <div class="data_card__info">
                  <div class="data_card__info--container">
                    <p class="data_card__info--title">
                      {{location.attributes.name}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Descripción</span>
                    <p class="data_card__info--text">
                      {{location.attributes.description}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Dirección</span>
                    <p class="data_card__info--text">
                      {{location.attributes.address}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Correo electrónico</span>
                    <p class="data_card__info--text">
                      {{location.attributes.email}}
                    </p>
                  </div>
                </div>
              </section>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button px-5"
          @click="createLocation()"
        >
          Crear
        </button>
      </div>
    </div>

  </article>
</template>

<script>
export default {
  data(){
    return{
      location:{
        attributes:{
          name: '',
          description: '',
          address: '',
          email: '',
          telephone: '',
          location_type: 'Entrenador',
          title: '',
          city: '',
          is_trainer: true,
          latitude: '',
          longitude: '',
          image: '',
          link: '',
          concept: '',
          nationality_code: '56',
          published: false,
          is_shopping_center: false,
          location_schedule_attributes:{}
        },
      },
      photo_name: 'No se han seleccionado archivos',
      url_change: false,
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      days: {
        monday:     {name: 'monday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'lunes'
                    },
        tuesday:    {name: 'tuesday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'martes'
                    },
        wednesday:  {name: 'wednesday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'miercoles'
                    },
        thursday:   {name: 'thursday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'jueves'
                    },
        friday:     {name: 'friday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'viernes'
                    },
        saturday:   {name: 'saturday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'sabado'
                    },
        sunday:     {name: 'sunday',
                     begin:'',
                     end:'',
                     type:'string',
                     name_esp: 'domingo'
                    }
      },
      works_on_sundays: false,
      works_on_holidays: false,
      hours: ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00',
              '10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00',
              '20:00','21:00','22:00','23:00'],
      time: null,
    }
  },
  mounted(){
    this.updateOffers([])
    this.findOffers()
    // cl offers_selected
  },
  watch: {
    url(){
      this.url_change = true;
    }
  },
  methods:{
    checkSchedule () {
      var vm = this
      Object.keys(vm.days).forEach(function (key) {
        // cl key, vm.days[key]
        if (vm.days[key].begin == '' || vm.days[key].end == '') {
          delete vm.days[key]
        }
      });
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.url = URL.createObjectURL(files[0]);
      this.createImage(files[0])
      this.photo_name = files[0].name
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.location.attributes.image = reader.result
      }
    },
    createLocation(){
      this.checkSchedule()
      this.location.attributes.location_schedule_attributes = this.days
      this.location.attributes.title = this.location.attributes.name
      this.$set(this.location.attributes.location_schedule_attributes, 'works_on_sundays', this.works_on_sundays)
      this.$set(this.location.attributes.location_schedule_attributes, 'works_on_holidays', this.works_on_holidays)
      // cl offers_selected
      // cl location
      try {
        this.$http.post('locations', {data: this.encrypt(this.location).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          this.$router.push({name: 'classes_trainers'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  }
}
</script>

<style>
  .text_title{
    font-weight: bold;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/classes/New_trainer.vue